import { App } from '@agilox/common';

export const NotificationApp = [
	App.my,
	App.analytics,
	App.manage,
	App.academy,
	App.lifecycle,
	App.plan,
	App.docs,
];
